/* shah */
import React from 'react'

const DropOfLiquidIcon = () => {
    return (
        <svg id="SmallBoxSVG-drop-Liquid" version="1.0" xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 512.000000 512.000000"
            preserveAspectRatio="xMidYMid meet">

            <g transform="translate(0.000000,512.000000) scale(0.100000,-0.100000)"
            >
                <path d="M2474 5098 c-51 -41 -431 -635 -712 -1114 -498 -850 -790 -1479 -908
-1954 -35 -144 -44 -377 -20 -535 90 -583 432 -1056 956 -1320 353 -178 807
-225 1203 -124 259 66 513 200 713 377 319 281 514 641 580 1067 24 158 15
391 -20 535 -117 469 -402 1087 -889 1920 -292 500 -678 1106 -731 1148 -22
17 -42 22 -86 22 -44 0 -64 -5 -86 -22z m214 -575 c637 -1003 1099 -1889 1258
-2417 46 -152 65 -264 65 -387 -1 -442 -217 -867 -578 -1138 -647 -486 -1548
-359 -2033 287 -236 315 -342 727 -271 1062 85 401 373 1028 854 1855 211 363
561 925 577 925 5 0 62 -84 128 -187z"/>
                <path d="M1439 1857 c-19 -12 -42 -39 -52 -60 -17 -34 -18 -48 -8 -155 38
-407 249 -736 603 -939 142 -82 282 -125 466 -144 136 -14 175 -6 221 46 26
30 31 44 31 86 0 30 -7 63 -17 79 -24 41 -82 70 -139 70 -344 1 -694 245 -820
572 -32 84 -64 236 -64 306 0 30 -7 69 -16 88 -34 72 -136 97 -205 51z"/>
            </g>
        </svg>
    )
}

export default DropOfLiquidIcon